"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDownMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DropDownMenu extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedValue: props.selectedValue
    };
    this.toggle = this.toggle.bind(this);
    this.changeValue = this.changeValue.bind(this);
  }
  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setState({
        selectedValue: this.props.selectedValue
      });
    }
  }
  changeValue(e) {
    this.setState({
      selectedValue: e.currentTarget.textContent
    });
  }
  render() {
    const {
      dropdownOpen,
      selectedValue = ''
    } = this.state;
    const {
      changeValue,
      className,
      dropDownItems
    } = this.props;
    const style = {
      color: '#b5babe',
      width: "1rem",
      height: "1rem",
      float: 'right'
    };
    const obj = this.props.changeValue ? changeValue : this.changeValue;
    return /*#__PURE__*/_react.default.createElement(_reactstrap.Dropdown, {
      disabled: dropDownItems.length === 0 ? true : false,
      isOpen: dropdownOpen,
      toggle: this.toggle,
      className: (0, _classnames.default)("ixn-dropdown ".concat(className))
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
      className: "ixn-dropdown__dropdown-component"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ixn-dropdown__dropdown-value"
    }, selectedValue), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'chevron-down'],
      style: style
    })), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, {
      className: "ixn-dropdown__dropdown-list"
    }, dropDownItems.map((item, key) => {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: "".concat(item).concat(key)
      }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
        header: true,
        className: "ixn-dropdownmenu__header"
      }, item.type), item.Values.map((value, index) => /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
        className: "ixn-dropdownmenu__action",
        key: "".concat(value).concat(index),
        onClick: event => {
          obj(event);
        }
      }, value)));
    })));
  }
}
exports.DropDownMenu = DropDownMenu;
DropDownMenu.defaultProps = {
  className: '',
  dropDownItems: []
};
DropDownMenu.propTypes = {
  /** Contain various classes which apply styling to dropdown */
  className: _propTypes.default.string,
  /** Array to contain dropdown list with MIME Type and it's scale values*/
  dropDownItems: _propTypes.default.array
};